// import React, { Component } from 'react';
import Tools from '../../../tools.js';
import API from '../../../api';
import React, { useState, useEffect } from "react";
import QuestList from './QuestList';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';

// fake data generator
// const getItems = count =>
//     Array.from({ length: count }, (v, k) => k).map(k => {
//         switch (k % 4) {
//             case 0:
//             default:
//                 return ({
//                     id: `item-${k}`,
//                     content: `item ${k}`,
//                     type: k % 4 + 1,  //1~4
//                     op: [
//                         { na: "選項0", o_type: 0 },
//                         { na: "選項1", o_type: 1 },
//                         { na: "選項2", o_type: 2 },
//                         { na: "選項3", o_type: 3 },
//                         { na: "選項4", o_type: 4 },
//                         { na: "選項5", o_type: 5 },
//                         { na: "選項6", o_type: 6 }
//                     ]
//                 });
//                 break;
//         }
//     });

// let isFetched = false;

export default function QuestAddCustApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [isInit, setIsInit] = useState(false);
    const [pi, setPi] = useState(props.pi || "");
    const items = useMappedState(state => state.items);
    const tmpItems = useMappedState(state => state.tmpItems);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("updated", isFetched);
        if (false == isFetched) {
            console.log(this);
            console.log(props);

            Tools.init();
            // API.init(this);

            getData(onDataUpdated);
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        var tmpData = {
            pi: pi
        };
        API.GetQuestionnaire(tmpData).
            then(onDataUpdated);
    }

    function onAdd() {
        let tmp = [...tmpItems];
        tmp.push({
            id: "item-" + tmp.length,
            cf: {
                q_type: 1,
                parameters: {
                    layout: 0,
                    random: { is_rand: 0 },
                    bonus: { has_bonus: 0, bonus: 0 }
                },
            },
            ma: {
                content: "",
                image: "",
                images: [],
                lnk: "",
                tag: "",
                timer: 0,
                video: ""
            },
            op: [{
                na: "選項1",
                o_type: 0
            }],
            ru: {
                route: { ty: 0, ta: [0] },
                bonus: { ty: 0 }
            }
        });
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onCopy(index) {
        let tmp = [...tmpItems];
        // console.log(tmp);
        let newItem = JSON.parse(JSON.stringify(tmp[index]));
        tmp.splice(index, 0, newItem);
        for (let i = 0; i < tmp.length; i++) {
            tmp[i].id = "item-" + i
        }
        // console.log(newItem, tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onRemove(index) {
        let tmp = [...tmpItems];
        tmp.splice(index, 1);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onBackgroundSave() {
        console.log(tmpItems);
        var tmpData = {
            pi: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.AddQuestionnaire(tmpData, tmpItems).
            then(checkResult);
    }

    function onSaveAndBack() {
        console.log(tmpItems);

        var tmpData = {
            pi: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.AddQuestionnaire(tmpData, tmpItems).
            then(checkResult).
            then((result) => {
                if (result) props.onBackToList();
                else console.log("failed");
            });
    }

    function onNext() {
        console.log(tmpItems);

        var tmpData = {
            pi: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.AddQuestionnaire(tmpData, tmpItems).
            then(checkResult).
            then((result) => {
                if (result) props.onNextStep();
                else console.log("failed");
            });
    }

    function checkResult(data) {
        // console.log(data);

        if (data && data.responseData) {
            try {
                alert(data.responseData.msg);
                if (data.responseData.code == "22000") {
                    getData();
                    return true;
                }
                return false;
            } catch (e) {
                alert("update error");
                console.warn(e.stack);
                return false;
            }
        }
    }

    function onDataUpdated(data) {
        // console.log(data);
        // setItem(tmp);

        if (data && data.response
            && data.response.status == 200 && data.responseData) {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: data.responseData } });
        } else {
            dispatch({
                type: "UPDATE_ITEM", data: {
                    pid: pi, items: [
                        {
                            "op": [{ "o_type": 0, "na": "選項1" }],
                            "cf": { "q_type": 1, "parameters": { "layout": 0, "random": { "is_rand": 0 }, "bonus": { "bonus": 0, "has_bonus": 0 } } },
                            "ru": { "route": { "ty": 0 }, "bonus": { "ty": 0 } },
                            "ma": { "image": "", "timer": 0, "images": [], "lnk": "", "video": "", "tag": "", "content": "" }
                        }
                    ]
                }
            });
        }
        setIsInit(true);
    }

    function render() {
        if (null == items) {
            if (isInit == true) {
                return <div>No Data</div>
            }
            return <div>loading...</div>
        } else {
            return (
                <Container className="App mb-50">
                    <QuestList onRemove={onRemove} onCopy={onCopy}></QuestList>
                    <Row>
                        {props.isEditable ? (<Col className="col text-center">
                            <Button onClick={onAdd}>新增題目</Button>
                        </Col>) : null}
                        <Col className="col text-center">
                            <Button onClick={onSaveAndBack}>儲存<br />(回專案列表)</Button>
                        </Col>
                        <Col className="col text-center">
                            <Button onClick={onNext}>設定完成，<br />下一步</Button>
                        </Col>
                    </Row>
                </Container>
            );
        }
    }
    return render();
}
